module.exports = __webpack_public_path__ + "static/media/bg_creditcards.4cf34e87.png";